import React, { FC, useEffect, useState } from 'react';

import TemplateAuthForm from 'components/auth/TemplateAuthForm';
import Button from 'components/common/ui-kit/Button';
import Captcha from 'components/common/ui-kit/Captcha';
import Checkbox from 'components/common/ui-kit/Checkbox';
import Input from 'components/common/ui-kit/Input';
import Link from 'components/common/ui-kit/Link';
import RouteButtonLink from 'components/common/ui-kit/RouteButtonLink';
import useSignUpEmailForm from 'hooks/auth/useSignUpEmailForm';
import useAppDispatch from 'hooks/common/useAppDispatch';
import terms from 'i18n';
import { createToast, showModal } from 'redux/actions';

import { EpguWarning } from '../SignUpForm/view';

type SignUpFormProps = {
  title: string;
};

const registrationStartDate = process.env.REACT_APP_REGISTRATION_START_DATE;
export const isRegistrationDisabled = registrationStartDate
  ? new Date(registrationStartDate) > new Date()
  : true;

const SignUpEmailForm: FC<SignUpFormProps> = ({ title }) => {
  const dispatch = useAppDispatch();
  const {
    fields,
    onSubmit,
    btnDisabled,
    errors,
    isConsentChecked,
    isPrivacyChecked,
  } = useSignUpEmailForm();

  const [captchaToken, setCaptchaToken] = useState('');
  const [isValid, setIsValid] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    if (!isValid) {
      dispatch(createToast(terms.CAPTCHA, 'danger'));
      return;
    }
    onSubmit(e);
  };

  useEffect(() => {
    dispatch(
      showModal({
        name: 'COOKIE_MODAL',
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setIsValid(!!captchaToken);
  }, [captchaToken]);

  return (
    <TemplateAuthForm title={title}>
      <EpguWarning />
      <form onSubmit={handleSubmit}>
        <div className="email-form__body">
          <div className="auth-form__fields">
            <Input
              placeholder={terms.EMAIL}
              className="auth-form__input"
              {...fields['email']}
              error={errors.email?.message}
            />
          </div>
          <Captcha onTokenChange={setCaptchaToken} />
        </div>
        <div className="auth-form__agreement">
          <h1
            style={{
              borderTop: '1px solid grey',
              paddingTop: '15px',
              marginTop: '30px',
            }}
          >
            {terms.PERSONAL_DATA}
          </h1>
          <div className="auth-form__checkboxes">
            <div className="checkbox-group">
              <Checkbox
                text={terms.USER_CONSENT}
                {...fields.consentToDataProcessing}
              />
              <Link href="/documents/personal_data.pdf" target="_blank">
                {terms.CONSENT_TO_DATA_PROCESSING}
              </Link>
            </div>

            <div className="checkbox-group">
              <Checkbox
                text={terms.USER_CONFIRM}
                {...fields.privacyPolicyAgreement}
              />
              <Link href="/documents/personal_data_policy.pdf" target="_blank">
                {terms.PRIVACY_POLICY}
              </Link>
            </div>
          </div>
        </div>
        <div className="auth-form__buttons">
          <RouteButtonLink to="/sign-in" className="auth-form__button">
            {terms.BACK}
          </RouteButtonLink>
          <Button
            id="auth-form__register-button"
            theme="success"
            className="auth-form__button"
            disabled={
              isRegistrationDisabled ||
              !captchaToken ||
              btnDisabled ||
              !isConsentChecked ||
              !isPrivacyChecked
            }
          >
            {terms.CONTINUE}
          </Button>
        </div>
      </form>
    </TemplateAuthForm>
  );
};

export default SignUpEmailForm;
